import React from 'react';

import NewComponent from './../../components/editor/components/NewComponent';
import DynamicField from '../../DynamicField';

const SSEditorForm = ({ id, childrenNodes }) => {
  return (
    <>
      {!childrenNodes.length && <NewComponent controlParentId={id} previousControlId="" />}
      {childrenNodes.map((childKey) => (
        <DynamicField key={childKey} id={childKey} />
      ))}
    </>
  );
};

export default SSEditorForm;
